<div class="wall-navbar-top">
  <div class="row border-bottom" *ngIf="!hideTopnavbar">
    <nav
      id="myNavbar"
      class="navbar navbar-static-top animated fadeInLeft"
      role="navigation"
      id="myNavbar"
    >
      <div class="navbar-left" *ngIf="isMobile">
        <a
          class="pull-left minimalize-styl-2"
          draggable="false"
          (click)="toggleNavigation()"
        >
          <i class="fa fa-tasks"></i>
        </a>
        <div
          class="img-class"
          [ngClass]="{'pointer-cursor' : (selectedRole?.role ==='Manager'),'pointerNone' : (selectedRole?.role!=='User')}"
        >
          <img
            class="site-logo"
            [src]="setLogo()"
            (click)="onMenuClick(nav)"
            [routerLink]="nav.routerLink"
            draggable="false"
          />
          <!-- [src]="coreService.getImageURL(userData.belongingCompanyLogo, 'assets/images/user.jpeg')" -->
        </div>
      </div>

      <div class="navbar-center pull-center">
        <ul
          id="topLinksBar"
          class="nav navbar-top-links text-center topicons no-slide"
        >
          <li class="menu_Icon regular" *ngIf="employees && !isMobile">
            <div class="input-group-typeahead" [ngClass]="{'fill-text': fillText}">
              <i
                class="fa fa-search"
                (click)="checkOpenList()"
              ></i>
              <input
                id="state"
                class="form-control typeahead"
                autocomplete="off"
                name="state"
                [(ngModel)]="searchEmployeeText"
                placeholder="{{'Generic.Search' | translate}}"
                [typeaheadOptionField]="'Name'"
                [typeaheadItemTemplate]="searchEmployeeTemplate"
                [typeaheadMinLength]="0"
                [typeaheadOptionsLimit]="employees.length"
                [typeahead]="employees"
                containerClass="employee-typeahead"
                (blur)="searchEmployeeText ? fillText=true : fillText=false"
              />
            </div>
          </li>
        </ul>

        <div class="relative" *ngIf="!isMobile">
          <div
            class="create-btn"
            (click)="addEvent()"
            [ngClass]="{'active': addBtn}"
            *ngIf="(userInfo.hasPatFeed && enablePatButton) || 
            (userInfo.hasTokenFeed && userInfo?.availableTokens>=0 && enableTokenButton) || 
            (userInfo.hasEvaluationFeed && enableFeedbackButton) || userInfo.canAddNews"
          >
            <span>{{"Create" | translate}}</span>
            <i class="fa fa-plus"></i>
          </div>

          <div *ngIf="addBtn" class="adjustment" id="popup">
            <div
              class="add"
              *ngIf="(userInfo.hasPatFeed) && enablePatButton"
              (click)="getNewPats()"
            >
              <div class="left hover-color">
                <i class="wallicon patpat-icon icon-logo"></i>
              </div>
              <div class="right hover-color">
                <div class="title">{{'Employee.Pat' | translate}}</div>
                <div class="regular">{{ 'GIVE_A_PAT' | translate }}</div>
              </div>
            </div>

            <div
              *ngIf="(userInfo.hasEvaluationFeed) && enableFeedbackButton"
              class="add colorChange"
              (click)="choicePop()"
            >
              <div class="left hover-color">
                <i class="wallicon fa fa-star"></i>
              </div>
              <div class="right hover-color">
                <div class="title">{{"Employee.FeedBack" | translate}}</div>
                <div class="regular">{{ 'GIVE_FEED_OR_ASK' | translate }}</div>
              </div>
            </div>

            <div
              *ngIf="userInfo.hasTokenFeed && userInfo?.availableTokens>=0 && enableTokenButton"
              class="add token-menu"
              (click)="getTokenPopUps()"
              (mouseenter)="tokenHover = true"
              (mouseleave)="tokenHover = false"
            >
              <div
                class="left"
                [ngClass]="{'hover-color': availableTokens > 0}"
              >
                <i class="wallicon fa fa-database"></i>
              </div>
              <div
                class="right"
                [ngClass]="{'hover-color': availableTokens > 0}"
              >
                <div class="title">{{"PRAISES.Tokens" | translate}}</div>
                <div class="regular flex">
                  {{ 'GIVE_TOKENS' | translate }}
                  <img
                    [ngStyle]="{'display': availableTokens <=  0 || !tokenHover ? 'block' : 'none' }"
                    height="11px"
                    src="./assets/images/icons/Budget.png"
                    draggable="false"
                  />
                  <img
                    [ngStyle]="{'display': availableTokens > 0 && tokenHover ? 'block' : 'none' }"
                    class="pointer"
                    height="11px"
                    src="./assets/images/icons/Budget-Color.png"
                    draggable="false"
                  />
                  {{availableTokens}}
                </div>
              </div>
            </div>

            <div
              *ngIf="(userInfo.canAddNews)"
              class="add colorChange"
              (click)="getNewsPopUps()"
            >
              <div class="left hover-color">
                <i class="wallicon fa fa-bullhorn"></i>
              </div>
              <div class="right hover-color">
                <div class="title">{{'Employee.News' | translate}}</div>
                <div class="regular">{{ 'ADD_NEWS' | translate }}</div>
              </div>
            </div>
          </div>
          <div
            class="backdrop-container-add"
            *ngIf="addBtn"
            (click)="onPopupClose()"
          ></div>
        </div>
      </div>

      <div class="notification-menu-container">
        <ul id="topLinksBar" class="nav navbar-top-links text-center topicons">
          <li
            class="menu_Icon open regular"
            container="body"
            id="notificationsLI"
            *ngIf="config && config.showIcons"
          >
            <a
              *ngIf="notifyRows && notifyRows.length>0"
              class="count-info"
              href="javascript:void(0);"
              aria-expanded="true"
              draggable="false"
              (click)="showHideAlerts()"
            >
              <i
                class="fa fa-bell regular menu-icon"
                [ngClass]="{'faa-ring animated': notifies > 0}"
              ></i>
              <span *ngIf="notifies > 0" class="label label-danger">
                {{notifies>9?'9+':notifies}}
              </span>
            </a>
            <div></div>
          </li>
        </ul>
        <img
          alt="image"
          class="img-circle"
          *ngIf="userInfo"
          (click)="openPopup()"
          draggable="false"
          [src]="coreService.getImageURL(userInfo.imageUrl,coreService.getDefaultImage())"
        />
        <div class="background-container" *ngIf="popupValue"></div>
      </div>
    </nav>
  </div>
  <!-- start -->
  <div
    class="popup-topnav notifi-popup white-shadow"
    id="popup"
    *ngIf="NotifyValue"
  >
    <div class="display-flex-column notification-menu">
      <div class="title">
        <div class="icon-mobile" *ngIf="isMobile">
          <i class="fa fa-angle-left" (click)="onPopupClose()"></i>
        </div>
        <div class="notification-name">
          {{"Messages.Notifications" | translate}}
        </div>
        <div class="icon" *ngIf="!isMobile">
          <i class="fa fa-x fa-remove" (click)="onPopupClose()"></i>
        </div>
        <div class="icon" *ngIf="isMobile" style="width: 10px"></div>
      </div>
      <div class="notify-border">
        <div
          class="notificationPanelEx"
          [ngClass]="{ showScroll: scrollShow }"
          (scroll)="scrollHandler($event)"
        >
          <div
            *ngFor="let item of notifyRows "
            style="border-bottom: 1px solid var(--login-textfield-color)"
          >
            <div
              class="alertElement"
              [ngClass]="{'azureBackground': !item.Viewed && item.NotificationType!=9, 'red-notice' : item.NotificationType==9}"
            >
              <div
                class="rows"
                style="
                  margin-top: 5px;
                  margin-bottom: 5px;
                  margin-right: 0px;
                  margin-left: 0px;
                  padding-top: 5px;
                  padding-bottom: 5px;
                "
              >
                <div class="display-flex-left flex-align-center">
                  <div style="width: 25px; flex: 0 0 25px; margin-right: 5px">
                    <i
                      class="medium patpat-icon icon-logo tiny"
                      *ngIf="item.NotificationType==1"
                    ></i>
                    <i
                      class="medium fa fa-database tiny"
                      *ngIf="item.NotificationType==2"
                    ></i>
                    <i
                      class="medium fa fa-star tiny"
                      *ngIf="item.NotificationType==3"
                    ></i>
                    <i
                      class="medium fa fa-star tiny"
                      *ngIf="item.NotificationType==4"
                    ></i>
                    <i
                      class="medium patpat-icon icon-boss_icon tiny"
                      *ngIf="item.NotificationType==5"
                    ></i>
                    <i
                      class="medium patpat-icon icon-boss_icon theRed"
                      *ngIf="item.NotificationType==6"
                    ></i>
                    <i
                      class="medium patpat-icon icon-self_icon theRed"
                      *ngIf="item.NotificationType==7"
                    ></i>
                    <i
                      class="medium patpat-icon icon-guru_simple tiny"
                      *ngIf="item.NotificationType==8"
                    ></i>
                    <i
                      class="medium fa fa-exclamation-triangle faa-flash animated theRed"
                      *ngIf="item.NotificationType==9"
                    ></i>
                    <i
                      class="medium fa fa-ban theRed"
                      *ngIf="item.NotificationType==10"
                    ></i>
                    <i
                      class="medium fa fa-bullseye tiny"
                      *ngIf="item.NotificationType==11"
                    ></i>
                    <i
                      class="medium fa fa-bullhorn tiny"
                      *ngIf="item.NotificationType==12"
                    ></i>
                    <i
                      class="medium fa fa-comment-o tiny"
                      *ngIf="item.NotificationType==13"
                    ></i>
                    <i
                      class="medium fa fa-heart-o tiny"
                      *ngIf="item.NotificationType==14"
                    ></i>
                    <i
                      class="medium patpat-icon icon-logo tiny"
                      *ngIf="item.NotificationType==15"
                    ></i>
                    <i
                      class="medium fa fa-trophy"
                      *ngIf="item.NotificationType==16"
                    ></i>
                  </div>
                  <div class="hoverPointer" (click)="viewNotify(item)">
                    <div
                      class="regular pointer"
                      style="word-break: break-all; width: 240px"
                    >
                      {{item.Description}}
                    </div>
                    <div class="tiny">{{item.Date | amTimeAgo}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="allRows.length>5 && !isMobile">
        <div class="setting-btn extra-setting">
          <div class="pointer" (click)="viewAllNotify()">
            <strong>{{'Messages.ViewAllNotify'|translate}}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end -->
  <div class="popup-topnav" id="popup" *ngIf="popupValue">
    <div class="popup-topnav-1">
      <button
        type="reset"
        class="btn btn-link fa fa-2x fa-remove"
        (click)="onPopupClose()"
      ></button>
    </div>
    <div class="popup-topnav-2">
      <img
        alt="image"
        class="img-popup"
        draggable="false"
        [src]="coreService.getImageURL(userInfo.imageUrl,coreService.getDefaultImage())"
      />
      <div class="popup-topnav-2-name">{{profileName}}</div>
      <div class="popup-topnav-2-email">{{userData.email}}</div>
    </div>
    <div class="popup-topnav-3">
      <div class="dropbox" *ngIf="roleArray.length > 1 && !isMobile">
        <mat-form-field appearance="outline">
          <mat-select
            [(ngModel)]="selectedRole"
            (selectionChange)="onRoleChange($event)"
            panelClass="topnav-role-select-panel"
          >
            <mat-select-trigger class="dropbox-trigger">
              {{selectedRole.text | translate}}
              <span>
                <mat-icon matSuffix class="{{selectedRole.class}}"></mat-icon>
              </span>
              <mat-icon
                matSuffix
                class="fa fa-chevron-down down-carat"
              ></mat-icon>
              <mat-icon matSuffix class="fa fa-chevron-up up-carat"></mat-icon>
            </mat-select-trigger>
            <mat-option
              *ngFor="let roles of roleArray"
              [value]="roles"
              class="dropbox-option"
            >
              <div></div>
              <div>{{ roles.text | translate }}</div>
              <div>
                <mat-icon
                  matSuffix
                  class="{{roles.class}} dropbox-option-1"
                ></mat-icon>
              </div>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <button *ngIf="!isRoleChange" class="setting-btn" (click)="onSetting()">
        {{"Menu.Settings"|translate}}
      </button>
    </div>
    <div *ngIf="!isRoleChange" class="popup-topnav-4">
      <div class="separator">
        <div class="or-line"></div>
        <div class="or-text">{{ 'Employee.or' | translate }}</div>
        <div class="or-line"></div>
      </div>
    </div>
    <div *ngIf="!isRoleChange" class="popup-topnav-5">
      <button class="btn btn-link btn-block" (click)="logout()" type="submit">
        {{ 'Menu.Logout' | translate }}
      </button>
    </div>

    <div *ngIf="isRoleChange" class="btn-cancel-save">
      <button class="btn btn-link btn-cancel" (click)="onCancel()">
        {{'CANCEL'|translate}}
      </button>
      <button class="btn btn-link btn-save" (click)="onSave()">
        {{'SAVE'|translate}}
      </button>
    </div>
  </div>

  <ng-template #searchEmployeeTemplate let-item="item">
    <div class="optionContainer">
      <div class="display-flex-space-between flex-align-center optionContainerRow">
        <div class="display-flex-left flex-align-center">
          <img
            class="categoryImg"
            draggable="false"
            [src]="coreService.getImageURL(item.Picture,'assets/images/user.jpeg')"
            (click)="goToStory(item, $event)"
          />
          <div class="option-info">
            <div class="name text-bold" (click)="goToStory(item, $event)">{{item.itemName}}</div>
            <div class="subtitle">
              <span *ngIf="item.Team">{{item.Team}}</span>
              <ng-container *ngIf="item.Team && item.Location"> • </ng-container>
              <span *ngIf="item.Location">{{item.Location}}</span>
            </div>
          </div>
        </div>
        <div class="action-btn"
          *ngIf="(item.ReceivePat && userInfo.hasPatFeed) ||
                 (item.ReceiveFeedback && userInfo.hasEvaluationFeed) ||
                 (tokenEligibleIds.has(item.Id) && userInfo.hasTokenFeed && userInfo?.availableTokens >= 0)">
          <i
            class="patpat-icon icon-logo"
            *ngIf="item.ReceivePat && userInfo.hasPatFeed"
            (click)="$event.stopPropagation(); getNewPat(item)"
            [attr.title]="'GIVE_A_PAT' | translate"
          ></i>
          <i
            class="fa fa-star"
            *ngIf="item.ReceiveFeedback && userInfo.hasEvaluationFeed"
            (click)="$event.stopPropagation(); getNewEvaluation(item)"
            [attr.title]="'GIVE_FEEDBACK' | translate"
          ></i>
          <i
            class="fa fa-database"
            *ngIf="tokenEligibleIds.has(item.Id) && userInfo.hasTokenFeed && userInfo?.availableTokens >= 0"
            (click)="$event.stopPropagation(); getTokenPopUp(item)"
            [attr.title]="'GIVE_TOKENS' | translate"
          ></i>
        </div>
      </div>
    </div>
  </ng-template>
  <div
    class="backdrop-container"
    *ngIf="popupValue"
    (click)="onPopupClose()"
  ></div>
  <div
    class="backdrop-container notify-backdrop"
    *ngIf="NotifyValue"
    (click)="onPopupClose()"
  ></div>
</div>
